import { t } from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getUserLocation } from '../../lib';
import { getCurrentUser } from './data';
import { errorReceiveCurrentUser, failedReceiveCurrentUser, failedReceiveUserLocation, receiveCurrentUser, receiveUserLocation } from './slice';
export function* requestCurrentUser(action) {
    try {
        const { consumerAPI } = action.payload;
        const response = yield call(getCurrentUser, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveCurrentUser());
            }
            else if (data && data.email) {
                yield put(receiveCurrentUser(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveCurrentUser());
            }
            else if (response && response.status === 200) {
                yield put(receiveCurrentUser(response.data, true));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveCurrentUser());
    }
}
export function* requestUserLocation() {
    try {
        const userLocation = yield call(getUserLocation);
        yield put(receiveUserLocation(userLocation));
    }
    catch (error) {
        yield put(failedReceiveUserLocation(error));
    }
}
export function* watchRequestCurrentUser() {
    yield takeLatest('user/requestCurrentUser', requestCurrentUser);
}
export function* watchRequestUserLocation() {
    yield takeLatest('user/requestUserLocation', requestUserLocation);
}
